import { render, staticRenderFns } from "./formActionsNext.vue?vue&type=template&id=6d10b4c1"
import script from "./formActionsNext.vue?vue&type=script&lang=js"
export * from "./formActionsNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d10b4c1')) {
      api.createRecord('6d10b4c1', component.options)
    } else {
      api.reload('6d10b4c1', component.options)
    }
    module.hot.accept("./formActionsNext.vue?vue&type=template&id=6d10b4c1", function () {
      api.rerender('6d10b4c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard-form/formStepActions/formActionsNext.vue"
export default component.exports